import { connect } from 'react-redux';
import StepSeats from './StepSeats.component';

import orderModule from 'app/store/order';
import paymentModule from 'app/store/payment';
import sessionsTicketsModule from 'app/store/sessionsTickets';
import concessions from 'app/store/concessions';

const { orderRequest } = orderModule.actions;
const { requestSesseionsBookingCount, requestSesseionsTickets } = sessionsTicketsModule.actions;
const {
  buyRequest,
} = paymentModule.actions;
const { setConcessionOnServer, setConcessionComboOnServer, setConcessionData } = concessions.actions;


const mapDispatchToProps = {
  orderRequest,
  buy: buyRequest,
  bookingCount: requestSesseionsBookingCount,
  requestSesseionsTickets: requestSesseionsTickets,
  setConcessionOnServer,
  setConcessionData,
  setConcessionComboOnServer
};

const mapStateToProps = ({ sessions, order, sessionId, cinemaId }) => ({
  wizard: sessions.wizard,
  isOrdered: !!order,
  order,
  sessionData: sessions,
  sessionId,
  cinemaId
});


export default connect(mapStateToProps, mapDispatchToProps)(StepSeats);
